import {Poly} from '../../../@polygonjs/polygonjs/src/engine/Poly';
import {ExpressionType} from '../../../@polygonjs/polygonjs/src/engine/expressions/methods/Common';
import {AppConfig} from '../../config/AppConfig';
export interface GetRegisteredExpressionsOptions {
	expressionNames: ExpressionType[];
}

export async function getRegisteredExpressions(options: GetRegisteredExpressionsOptions) {
	await AppConfig.register({sceneName: null});
	const {expressionNames} = options;
	const expressionNamesSet: Set<ExpressionType> = new Set();
	Poly.expressionsRegister.availableMethods().forEach((expressionName) => {
		expressionNamesSet.add(expressionName);
	});
	expressionNames.splice(0, expressionNames.length);
	expressionNamesSet.forEach((expressionName) => expressionNames.push(expressionName));
}
